"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFee = createFee;
exports["default"] = void 0;
exports.deleteFee = deleteFee;
exports.getContractFees = getContractFees;
exports.getContractFeesCount = getContractFeesCount;
exports.getFee = getFee;
exports.getFeeCurrencyRates = getFeeCurrencyRates;
exports.getFeeInvoicesAndCreditNotes = getFeeInvoicesAndCreditNotes;
exports.getGeneralFees = getGeneralFees;
exports.getTeamUnits = getTeamUnits;
exports.getUnitValues = getUnitValues;
exports.saveBackdatingFee = saveBackdatingFee;
exports.updateFee = updateFee;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var base = '/api/fee';

function getFee(feeId) {
  return _api["default"].get("".concat(base, "/").concat(feeId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function createFee(feeFormData) {
  var feeData = feeFormData;
  return _api["default"].post(base, feeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateFee(feeId, feeFormData) {
  var feeData = feeFormData;
  return _api["default"].put("".concat(base, "/").concat(feeId), feeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function saveBackdatingFee(feeId, feeData) {
  return _api["default"].put("".concat(base, "/").concat(feeId, "/backdating"), feeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteFee(feeId) {
  return _api["default"]["delete"]("".concat(base, "/").concat(feeId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getUnitValues(feeData) {
  return _api["default"].post('/api/unit-values', feeData).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContractFees(contractId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return _api["default"].get("".concat(base, "/contract/").concat(contractId, "?page=").concat(page, "&limit=").concat(limit)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getContractFeesCount(contractId) {
  return _api["default"].get("".concat(base, "/contract/").concat(contractId, "?count")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getGeneralFees(data) {
  return _api["default"].post("/api/report/general-fees", data).then(_api.extractData)["catch"](_api.errorHandler);
}

function getFeeInvoicesAndCreditNotes(feeId) {
  return _api["default"].get("".concat(base, "/").concat(feeId, "/invoices-and-credit-notes")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getFeeCurrencyRates(feeIds) {
  return _api["default"].post("".concat(base, "/currency-rates"), feeIds).then(_api.extractData)["catch"](_api.errorHandler);
}

function getTeamUnits(eteId) {
  return _api["default"].get("".concat(base, "/team-units/").concat(eteId)).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  getFee: getFee,
  createFee: createFee,
  updateFee: updateFee,
  deleteFee: deleteFee,
  getContractFees: getContractFees,
  getContractFeesCount: getContractFeesCount,
  getUnitValues: getUnitValues,
  getTeamUnits: getTeamUnits,
  getInvoicesAndCreditNotes: getFeeInvoicesAndCreditNotes,
  saveBackdatingFee: saveBackdatingFee
};
var _default = api;
exports["default"] = _default;